import { PetType } from 'constants/pet-type';
import {
  AgeSegmentationIds,
  AllAllergySegmentationIds,
  BreedSegmentationIds,
  CatNutritionSegmentationIds,
  NutritionSegmentationIds,
  ProteinTagValues,
  SegmentationIds,
} from 'constants/segmentation';
import {
  InputProductType,
  WetFoodTagValues,
} from 'interfaces/api-input/input-product-type';

/** Base interface for common properties between dog and cat profiles */
export interface BasePetProfile {
  id?: string;
  petType: (typeof PetType)[keyof typeof PetType];
  selectedAge?: AgeSegmentationIds;
  selectedNeeds?: Array<NutritionSegmentationIds | CatNutritionSegmentationIds>;
  selectedAllergies?: Array<AllAllergySegmentationIds>;
  selectedFoodTypes?: Array<InputProductType>;
  lastTouched?: SegmentationIds;
  updatedAt?: string;
  selectedWeight?: number;
  name?: string;
}

/** Dog-specific profile interface */
export interface DogProfile extends BasePetProfile {
  petType: typeof PetType.Dog;
  selectedBreed?: BreedSegmentationIds;
}

/** Cat-specific profile interface */
export interface CatProfile extends BasePetProfile {
  petType: typeof PetType.Cat;
  selectedWetFoodTypes: WetFoodTagValues[];
  selectedTastePreferences: ProteinTagValues[];
}

/** Type guard to check if profile is a dog profile */
export function isDogProfile(profile: PetProfile): profile is DogProfile {
  return profile.petType === PetType.Dog;
}

/** Type guard to check if profile is a cat profile */
export function isCatProfile(profile: PetProfile): profile is CatProfile {
  return profile.petType === PetType.Cat;
}

export type PetProfile = DogProfile | CatProfile;

/** Interface for managing multiple pet profiles */
export interface PetProfiles {
  dog: DogProfile | null;
  cat: CatProfile | null;
  activeType: (typeof PetType)[keyof typeof PetType];
}
